module.exports = __webpack_public_path__ + "img/next-arrow-icon.f43a1607.svg";